import { AuthoritiesType } from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Select, SelectProps } from 'antd';
import React, { forwardRef } from 'react';
import { AlertCircle } from 'react-feather';

interface Props extends SelectProps {
  hasNextPage?: boolean;
  fetchNextPage: () => void;
  permissions?: AuthoritiesType[];
  somePermission?: boolean;
}

const InfiniteSelect = forwardRef<BaseSelectRef, Props>(
  (
    { hasNextPage, fetchNextPage, permissions, somePermission, ...props },
    ref,
  ) => {
    const notHasPermissions = permissions
      ? !hasPermissions(permissions, somePermission)
      : undefined;

    return (
      <Select
        {...props}
        ref={ref}
        disabled={notHasPermissions || props.disabled}
        suffixIcon={notHasPermissions && <AlertCircle />}
        style={{ width: '100%', ...props.style }}
        onPopupScroll={(event) => {
          const { scrollTop, offsetHeight, scrollHeight } = event.currentTarget;

          const distanceFromBottom = scrollHeight - (scrollTop + offsetHeight);

          const tolerance = 1;

          if (
            !props.loading &&
            distanceFromBottom <= tolerance &&
            hasNextPage
          ) {
            fetchNextPage();
          }
        }}
      />
    );
  },
);

export default InfiniteSelect;
